import { render, staticRenderFns } from "./PengajuanNomorSurat.vue?vue&type=template&id=13535288"
import script from "./PengajuanNomorSurat.vue?vue&type=script&lang=js"
export * from "./PengajuanNomorSurat.vue?vue&type=script&lang=js"
import style0 from "./PengajuanNomorSurat.vue?vue&type=style&index=0&id=13535288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports